
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { HelpService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private loading = false
    private form = {
        name: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                this.loading = true
                const result = await HelpService.createArticleType({ name: this.form.name })
                if (result.status === 200) {
                    this.$msuccess('创建成功!')
                }
                this.loading = false
            }
        })
    }
}
